import { useSelector } from 'react-redux'
import { OptionItemInterface, ValidationResultInterface } from '../../types/interfaces'
import classes from './SearchSelect.module.sass'
import { useSearchSelect } from './hooks/useSearchSelect'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  label?: string
  options: OptionItemInterface[]
  value?: string | number | readonly string[] | undefined
  onChangeHandler: (value: string | number | boolean, fieldName: string, type: string) => void
  fieldName: string
  type: string
  onBlur?: (fieldName: string) => void
  itemValidationResult?: ValidationResultInterface
  disabled?: boolean
  placeholder: string
  keySelectField?: string
  multi?: boolean
}

export const SearchSelect = ({
  label,
  options,
  value,
  onChangeHandler,
  fieldName,
  type,
  onBlur,
  itemValidationResult,
  disabled,
  placeholder,
  multi,
}: Props) => {
  const {
    filteredList,
    searchString,
    setSearchString,
    expanded,
    setExpanded,
    onBlurAction,
    createDivRef,
    setFocusedIndex,
    handleKeyDown,
  } = useSearchSelect(options, onChangeHandler, fieldName, type, value)
  const dark = useSelector(selectDarkTheme)

  return (
    <div className={classes.SelectContainer}>
      {label && <label className={classes.Label}>{label}</label>}
      <input
        onKeyDown={(e) => {
          handleKeyDown(0, e)
        }}
        tabIndex={-1}
        //@ts-ignore
        ref={createDivRef(0)}
        disabled={disabled}
        value={value || value === 0 ? options.find((el) => el.value === String(value))?.label : searchString}
        type="text"
        placeholder={placeholder}
        onFocus={() => {
          onChangeHandler('', fieldName, type)
          setSearchString('')
          setExpanded(true)
        }}
        onBlur={() => {
          onBlur && onBlur(fieldName)
          onBlurAction()
        }}
        className={
          itemValidationResult?.isEmptyError && dark
            ? classes.ContainerRequiredDark
            : itemValidationResult?.isEmptyError
            ? classes.ContainerRequired
            : dark
            ? classes.ContainerDark
            : classes.Container
        }
        onChange={(e) => setSearchString(e.target.value)}
        onClick={() => {
          setFocusedIndex(0)
        }}
      />

      {expanded && filteredList.length > 0 && (
        <div className={classes.OptionsContainerAnchor}>
          <div className={!dark ? classes.OptionsContainer : classes.OptionsContainerDark}>
            {filteredList.map((el, index) => (
              <div
                tabIndex={-1}
                ref={createDivRef(index + 1)}
                onClick={() => {
                  el.value && setSearchString(el.label)
                  el.value && onChangeHandler(el.value, fieldName, type)
                }}
                className={!dark ? classes.Option : classes.OptionDark}
                key={el.id}
                hidden={el.hidden}
                defaultValue={el.value}
                onKeyDown={(e) => {
                  handleKeyDown(index, e)
                }}
              >
                {el.label}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={classes.ValidationErrorField}>
        {itemValidationResult?.isDirty &&
          itemValidationResult.notValid &&
          itemValidationResult?.errorMessage}
      </div>
    </div>
  )
}
